import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RestauInfoContext } from '../home/RestauInfoContext.js';
import { useStyles } from '../home/styles/useStyles';
import { Stack, Typography, Box, Paper, Divider } from '@mui/material';
import SquareIntegration from './SquareIntegration.js';
import CloverIntegration from './CloverIntegration.js';
import ExistingIntegrations from './ExistingIntegrations.js';
import axios from 'axios';
import Config from '../config/Config.js';

export default function POS() {
    const resauInfoContext = useContext(RestauInfoContext);
    const restauHook = resauInfoContext.restauHook;
    const navigate = useNavigate();

    const [posSetting, setPosSetting] = React.useState(undefined);
    const [isPrint, setPrint] = React.useState(false);
    const [isUnPaid, setUnPaid] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const [saveMessage, setSaveMessage] = React.useState('');
    const [selectedPOS, setSelectedPOS] = React.useState(null);
    const [integratedPOS, setIntegratedPOS] = React.useState(null);
    const [existingRestauPosMapping, setExistingRestauPosMapping] =
        React.useState({});
    const [restauIdsWithAccess, setRestauIdsWithAccess] = React.useState({});
    const classes = useStyles();

    async function handleChange(e) {
        console.log('target value');
        console.log(e.target.value);
        if (e.target.value === 'clover') {
            setPrint('clover');
        } else {
            setPrint('strideq');
        }
    }

    async function handleUnPaidChange(e) {
        if (e.target.value === 'unpaid') {
            setUnPaid('unpaid');
        } else {
            setUnPaid('paid');
        }
    }

    async function updateSettings(restauHook) {
        let updates = {};
        const database = window.customerApp.database();
        setSaveMessage('');
        setLoaded(true);
        let printSettings = false;
        let unPaidSetting = false;
        if (isUnPaid === 'unpaid') {
            unPaidSetting = true;
        }
        if (isPrint === 'clover') {
            printSettings = true;
        }
        updates['integrations/config/' + restauHook.restauId + '/isPrint'] =
            printSettings;
        updates['integrations/config/' + posSetting.merchantId + '/isPrint'] =
            printSettings;
        console.log(
            'update config',
            'integrations/config/' + posSetting.merchantId + '/isPrint'
        );
        console.log(updates);
        await database
            .ref()
            .update(updates)
            .then(function () {
                setSaveMessage('Succesfully updated');
            })
            .catch(function (error) {
                alert('Error while saving please try again');
                console.log(error);
                setLoaded(false);
                return;
            });

        let unPaidSettingUpdate = {};
        unPaidSettingUpdate[
            'menus/' +
                restauHook.restauId +
                '/payments/thirdparty/pay_at_restaurant'
        ] = unPaidSetting;
        await database
            .ref()
            .update(unPaidSettingUpdate)
            .then(function () {
                setSaveMessage('Succesfully updated');
            })
            .catch(function (error) {
                alert('Error while saving please try again');
                console.log(error);
                setLoaded(false);
                return;
            });
        setLoaded(false);
    }

    async function loadData(restauHook) {
        if (!window.customerApp.auth().currentUser) {
            navigate('/login');
            return;
        }
        if (!restauHook.restauId) {
            return;
        }
        const token = await window.customerApp.auth().currentUser.getIdToken();

        let config = {
            headers: {
                token: token,
            },
        };
        console.log('Restau Hook from restaurant: ' + restauHook.restauId);

        // Load POS settings and mappings
        try {
            const response = await axios.post(
                Config.getPosSettings,
                {
                    restauId: restauHook.restauId,
                },
                {
                    headers: {
                        token: token,
                    },
                }
            );

            if (response.data && response.data.status) {
                if (response.data.data.restauIdsWithAccess) {
                    setRestauIdsWithAccess(
                        response.data.data.restauIdsWithAccess
                    );
                }
                if (response.data.data.posIntegrationsData) {
                    setExistingRestauPosMapping(
                        response.data.data.posIntegrationsData
                    );
                }
            }
        } catch (error) {
            console.error('Error loading POS settings:', error);
        }

        const admin = window.customerApp.database();
        let posRef = admin.ref('integrations/config/' + restauHook.restauId);
        let payAtRef = admin.ref(
            'menus/' +
                restauHook.restauId +
                '/payments/thirdparty/pay_at_restaurant'
        );
        console.log('integrations/config/' + restauHook.restauId);
        payAtRef
            .once('value')
            .then(function (snapshot) {
                let result = snapshot.val();
                console.log('Pay At restaurant setting: ', result);
                setUnPaid(result ? 'unpaid' : 'paid');
                setLoaded(false);
                console.log(posSetting);
                return result;
            })
            .catch(function (error) {
                setLoaded(false);
                console.log(error);
            });
        const pos = await posRef
            .once('value')
            .then(function (snapshot) {
                let result = snapshot.val();
                console.log('IntegrattionConfig: ', result);
                setPrint(result && result.isPrint ? 'clover' : 'strideq');
                if (result) {
                    setPosSetting(result);
                    // Check if POS integration exists
                    if (result.square) {
                        console.log('Square integration found:', result.square);
                        setIntegratedPOS('square');
                    } else if (result.provider === 'CLOVER') {
                        setIntegratedPOS('clover');
                    }
                } else {
                    setPosSetting({});
                }
                setLoaded(false);
                console.log(posSetting);
                return result;
            })
            .catch(function (error) {
                setLoaded(false);
                setPosSetting({});
                setIntegratedPOS(null);
                console.log(error);
            });
        return;
    }

    useEffect(() => {
        setLoaded(true);
        loadData(restauHook);
    }, [restauHook.restauId]);

    return (
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 3, md: 10 }}
            sx={{ width: '100%' }}
        >
            <Box sx={{ width: { xs: '100%', md: '50%' } }}>
                {/* Section 1: Add New Integration */}
                <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4 }}>
                    <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
                        Add New Integration
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 3 }}
                    >
                        Connect to a POS system and map your restaurants to
                        their locations
                    </Typography>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={2}
                        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
                    >
                        <SquareIntegration
                            onIntegrationComplete={() => {
                                setLoaded(true);
                                loadData(restauHook);
                            }}
                            existingRestauPosMapping={existingRestauPosMapping}
                            restauIdsWithAccess={restauIdsWithAccess}
                        />
                        <CloverIntegration />
                    </Stack>
                </Paper>

                <Divider sx={{ my: 4 }} />

                {/* Section 2: Existing Integrations */}
                <Paper sx={{ p: { xs: 2, sm: 3 } }}>
                    <ExistingIntegrations
                        existingRestauPosMapping={existingRestauPosMapping}
                        setExistingRestauPosMapping={
                            setExistingRestauPosMapping
                        }
                        restauIdsWithAccess={restauIdsWithAccess}
                        loading={loaded}
                        setLoading={setLoaded}
                        restauId={restauHook.restauId}
                    />
                </Paper>
            </Box>

            <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
                {!posSetting ? (
                    <Box sx={{ textAlign: 'center' }}>
                        <img
                            className={classes.loadingImage}
                            src="../../img/spinner.gif"
                        />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ maxWidth: { xs: '100%', sm: 350 } }}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">
                                    Print Setting
                                </FormLabel>
                                <RadioGroup
                                    aria-label="print1"
                                    name="print1"
                                    value={isPrint}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel
                                        value="strideq"
                                        control={<Radio />}
                                        label="Print Using StrideQ"
                                    />
                                    <FormControlLabel
                                        value="clover"
                                        control={<Radio />}
                                        label="Print Using Clover"
                                    />
                                </RadioGroup>
                                <br />
                                <FormLabel component="legend">
                                    Pay At Restaurant
                                </FormLabel>
                                <RadioGroup
                                    aria-label="payAtRestaurant"
                                    name="payAtRestaurant"
                                    value={isUnPaid}
                                    onChange={handleUnPaidChange}
                                >
                                    <FormControlLabel
                                        value="unpaid"
                                        control={<Radio />}
                                        label="Pay At Restaurant"
                                    />
                                    <FormControlLabel
                                        value="paid"
                                        control={<Radio />}
                                        label="Only Paid Orders"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Box>

                        {loaded === true ? (
                            <Box sx={{ textAlign: 'center', mt: 2 }}>
                                <img
                                    height="75px"
                                    className={classes.loadingImage}
                                    src="../../img/spinner.gif"
                                />
                            </Box>
                        ) : (
                            <>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        maxWidth: { xs: '100%', sm: 350 },
                                        mt: 2,
                                    }}
                                >
                                    <Button
                                        size="medium"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            updateSettings(restauHook);
                                        }}
                                        sx={{
                                            width: { xs: '100%', sm: 200 },
                                        }}
                                    >
                                        Update
                                    </Button>
                                </Box>
                                <Box
                                    sx={{
                                        pl: { xs: 0, sm: 1 },
                                        mt: 1,
                                        textAlign: { xs: 'center', sm: 'left' },
                                    }}
                                >
                                    {saveMessage}
                                </Box>
                            </>
                        )}
                    </>
                )}
            </Box>
        </Stack>
    );
}
